const store = {
    namespaced: true,
    state: {
        search: "",
        suggestions: []
    },
    mutations: {
        /**
         * Set the search term.
         *
         * @param {State} state The Vuex state.
         * @param {String} search The search term.
         */
        setSearch: function(state, search) {
            if (state.search !== search) {
                state.search = search;
            }
        },
    }
};

export default store;